import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { registerField } from 'core/forms';
import { TextArea } from 'uikit/inputs';
import styles from '../styles/formFieldTextArea.module.scss';

const FormFieldTextArea = ({ fieldId, value, updateField, schema }) => (
  <TextArea
    id={fieldId}
    className={classnames(styles.element, schema.className)}
    placeholder={schema.placeholder}
    value={value === null ? '' : value}
    onChange={updateField}
    isDisabled={schema.isDisabled}
    maxLength={schema.maxLength}
  />
);

FormFieldTextArea.defaultProps = {
  value: '',
  schema: {
    className: '',
    placeholder: '',
    isDisabled: false,
    maxLength: null,
  },
};

FormFieldTextArea.propTypes = {
  fieldId: PropTypes.string.isRequired,
  value: PropTypes.string,
  updateField: PropTypes.func.isRequired,
  schema: PropTypes.shape({
    placeholder: PropTypes.string,
    isDisabled: PropTypes.bool,
    maxLength: PropTypes.number,
  }),
};

registerField('TextArea', React.memo(FormFieldTextArea));

export default FormFieldTextArea;
